import _ from 'lodash'
import styled from 'styled-components'
import { WordWraps } from 'common-components'

import { getRiderPlanCode as getMCIRiderPlanCode } from 'core/service/rider/rider-mci'
import { getMCIExceptionNotes, getMCIExplanationNotes } from 'core/service/rider/benefits/exception-notes'

import { renderListItems } from 'quick-quote/util/html-render-utils'
import RiderBenefitSummary from './rider-benefit-summary'
import RiderWithBenefitModal from './rider-benefit-modal'
import { AdditionalDisclaimer } from './additional-disclaimer'

import MESSAGES from 'core/data-model/constants/bi-messages'
import VALUES from 'core/data-model/constants/values'

const BoldStyled = styled.span`
  font-weight: bold;
  margin-right: 10px;
`
const CenterStyled = styled.div`
  text-align: center;
`
const UnderlineStyled = styled.div`
  text-decoration: underline;
`
const ItalicStyled = styled.div`
  font-style: italic;
`

export const findDataOnListByRiderCode = (contents, planCode) => {
  return contents.find((content) => content.planCode === planCode)
    ? contents.find((content) => content.planCode === planCode).value
    : '-'
}

const renderExceptionNotes = (rider) => {
  const exceptionNotes = getMCIExceptionNotes()
  const exceptionTitle = exceptionNotes.title
  const [
    normalConditionSubject,
    firstException,
    secondException,
    thirdException,
    extendExceptionTitle,
    extendExceptionDesc,
    warningTitle,
    warningDesc,
  ] = exceptionNotes.exceptions

  return (
    <div id="meh-exception-note32">
      <p></p>
      <p>
        <h3>{exceptionTitle}</h3>
      </p>
      <p>
        <h3>{normalConditionSubject} </h3>
      </p>
      <ol id="meh-exception-list">
        <li>{firstException}</li>
        <li>{secondException}</li>
        <li>
          <div>{thirdException[0]}</div>
          <div>{thirdException[1]}</div>
          <ol className="list-cell">
            <li>
              <span>{'(1)'}</span>
              <span>{thirdException[2][0]}</span>
            </li>
            <li>
              <span>{'(2)'}</span>
              <span>{thirdException[2][1]}</span>
            </li>
          </ol>
        </li>
      </ol>
      <p>
        <h3>{extendExceptionTitle}</h3>
      </p>
      <div>
        <UnderlineStyled>{extendExceptionDesc[0]}</UnderlineStyled>
      </div>
      <div>{extendExceptionDesc[1]}</div>
      <ol>{renderListItems(extendExceptionDesc[2], 0, 5)}</ol>
      <p>
        <h3>{warningTitle}</h3>
      </p>
      <div>{warningDesc[0]}</div>
      <ol style={{ 'margin-bottom': '0' }}>
        <li key={`data_`}>
          <span
            dangerouslySetInnerHTML={{
              __html: `${warningDesc[1][0].split(' ').slice(0, 1)}
              <strong>${warningDesc[1][0].split(' ').slice(1, 2)}</strong>
                ${warningDesc[1][0]
                  .split(' ')
                  .slice(2)
                  .join(' ')}`,
            }}
          />
        </li>
        {renderListItems(warningDesc[1], 1, 4)}
      </ol>
    </div>
  )
}

const renderExplanationNotes = (insureAge) => {
  const explanationNotes = getMCIExplanationNotes()
  const explanationTitle = explanationNotes.title
  const [
    note_1,
    [
      note_1_1,
      [note_1_1_1, note_1_1_2, note_1_1_3, note_1_1_4],
      note_1_2,
      note_1_3,
      note_1_4,
      note_1_5,
      note_1_6,
      note_1_7,
      [note_1_7_1, note_1_7_2, note_1_7_3],
      note_1_8,
      note_1_9,
      note_1_10,
      [note_1_10_1, note_1_10_2, note_1_10_3],
    ],
    note_2,
    [note_2_1, [note_2_1_1, note_2_1_2], note_2_2, note_2_3, note_2_4, [note_2_4_1, note_2_4_2, note_2_4_3]],
  ] = explanationNotes.explanations

  const [note_1_3_split, note_1_4_split, note_1_5_split, note_1_6_split, note_1_9_split, note_2_1_2_split] = [
    note_1_3.split('\n'),
    note_1_4.split('\n'),
    note_1_5.split('\n'),
    note_1_6.split('\n'),
    note_1_9.split('\n'),
    note_2_1_2.split('\n'),
  ]

  return (
    <div id="meh-exception-note32">
      <p></p>
      <p>
        <h3>{explanationTitle}</h3>
      </p>
      <ol id="meh-exception-list">
        <li>
          <div>
            <strong>{note_1}</strong>
          </div>
          <ol className="list-cell">
            <li>
              <span>{'1.1'}</span>
              <span>
                <strong>{note_1_1.split(')').slice(0, 1)})</strong>
                <br />
                {note_1_1
                  .split(')')
                  .slice(1)
                  .join(') ')}
              </span>
              <ol className="list-cell">
                <li>
                  <span>{'(1)'}</span>
                  <span>{note_1_1_1}</span>
                </li>
                <li>
                  <span>{'(2)'}</span>
                  <span>{note_1_1_2}</span>
                </li>
                <li>
                  <span>{'(3)'}</span>
                  <span>{note_1_1_3}</span>
                </li>
                <li>
                  <span>{'(4)'}</span>
                  <span>{note_1_1_4}</span>
                </li>
              </ol>
            </li>
            <li>
              <span>{'1.2'}</span>
              <span>
                <strong>{note_1_2.split(')').slice(0, 1)})</strong>
                <br />
                {note_1_2
                  .split(')')
                  .slice(1)
                  .join(') ')}
              </span>
            </li>
            <li>
              <span>{'1.3'}</span>
              <span>
                <strong>{note_1_3_split[0].split(')').slice(0, 1)})</strong>
                <br />
                {note_1_3_split[0]
                  .split(')')
                  .slice(1)
                  .join(') ')}
                <br />
                {note_1_3_split[1]}
              </span>
            </li>
            <li>
              <span>{'1.4'}</span>
              <span>
                <strong>{note_1_4_split[0].split(')').slice(0, 1)})</strong>
                <br />
                {note_1_4_split[0]
                  .split(')')
                  .slice(1)
                  .join(') ')}
                <br />
                {note_1_4_split[1]}
              </span>
            </li>
            <li>
              <span>{'1.5'}</span>
              <span>
                <strong>{note_1_5_split[0].split(')').slice(0, 1)})</strong>
                <br />
                {note_1_5_split[0]
                  .split(')')
                  .slice(1)
                  .join(') ')}
                <br />
                {note_1_5_split[1]}
              </span>
            </li>
            <li>
              <span>{'1.6'}</span>
              <span>
                <strong>{note_1_6_split[0].split(')').slice(0, 1)})</strong>
                <br />
                {note_1_6_split[0]
                  .split(')')
                  .slice(1)
                  .join(') ')}
                <br />
                {note_1_6_split[1]}
              </span>
            </li>
            <li>
              <span>{'1.7'}</span>
              <span>
                <strong>{note_1_7.split(')').slice(0, 1)})</strong>
                <br />
                {note_1_7
                  .split(')')
                  .slice(1)
                  .join(') ')}
              </span>
              <ol className="list-cell">
                <li>
                  <span>{'(1)'}</span>
                  <span>{note_1_7_1}</span>
                </li>
                <li>
                  <span>{'(2)'}</span>
                  <span>{note_1_7_2}</span>
                </li>
                <li>
                  <span>{'(3)'}</span>
                  <span>{note_1_7_3}</span>
                </li>
              </ol>
            </li>
            <li>
              <span>{'1.8'}</span>
              <span>
                <strong>{note_1_8.split(')').slice(0, 1)})</strong>
                <br />
                {note_1_8
                  .split(')')
                  .slice(1)
                  .join(') ')}
              </span>
            </li>
            <li>
              <span>{'1.9'}</span>
              <span>
                <strong>{note_1_9_split[0].split(')').slice(0, 1)})</strong>
                <br />
                {note_1_9_split[0]
                  .split(')')
                  .slice(1)
                  .join(') ')}
                <br />
                {note_1_9_split[1]} <br />
                {note_1_9_split[2]} <br />
                {note_1_9_split[3]} <br />
                {note_1_9_split[4]} <br />
                {note_1_9_split[5]}
              </span>
            </li>
            <li>
              <span>{'1.10'}</span>
              <span>
                <strong>{note_1_10.split(')').slice(0, 1)})</strong>
                <br />
                {note_1_10
                  .split(')')
                  .slice(1)
                  .join(') ')}
              </span>
              <ol className="list-cell">
                <li>
                  <span>{'(1)'}</span>
                  <span>{note_1_10_1}</span>
                </li>
                <li>
                  <span>{'(2)'}</span>
                  <span>{note_1_10_2}</span>
                </li>
                <li>
                  <span>{note_1_10_3}</span>
                </li>
              </ol>
            </li>
          </ol>
        </li>
        {insureAge.value <= 10 ? (
          <li>
            <div>
              <strong>
                {note_2
                  .split(' ')
                  .slice(0, 2)
                  .join(' ')}{' '}
              </strong>
              <br />
              {note_2
                .split(' ')
                .slice(2)
                .join(' ')}
            </div>
            <ol className="list-cell">
              <li>
                <span>{'2.1'}</span>
                <span>
                  <strong>{note_2_1.split(')').slice(0, 1)})</strong>
                  <br />
                  {note_2_1
                    .split(')')
                    .slice(1)
                    .join(') ')}
                </span>
                <ol className="list-cell">
                  <li>
                    <span>{'(1)'}</span>
                    <span>{note_2_1_1}</span>
                  </li>
                  <li>
                    <span>{'(2)'}</span>
                    <span>
                      {note_2_1_2_split[0]} <br />
                      {note_2_1_2_split[1]}
                    </span>
                  </li>
                </ol>
              </li>
              <li>
                <span>{'2.2'}</span>
                <span>
                  <strong>{note_2_2.split(')').slice(0, 1)})</strong>
                  <br />
                  {note_2_2
                    .split(')')
                    .slice(1)
                    .join(') ')}
                </span>
              </li>
              <li>
                <span>{'2.3'}</span>
                <span>
                  <strong>{note_2_3.split(')').slice(0, 1)})</strong>
                  <br />
                  {note_2_3
                    .split(')')
                    .slice(1)
                    .join(') ')
                    .replace(/\n/g, '')}
                </span>
              </li>
              <li>
                <span>{'2.4'}</span>
                <span>
                  <strong>{note_2_4.split(')').slice(0, 1)})</strong>
                  <br />
                  {note_2_4
                    .split(')')
                    .slice(1)
                    .join(') ')}
                </span>
                <ol className="list-cell">
                  <li>
                    <span>{'(1)'}</span>
                    <span>{note_2_4_1}</span>
                  </li>
                  <li>
                    <span>{'(2)'}</span>
                    <span>{note_2_4_2}</span>
                  </li>
                  <li>
                    <span>{note_2_4_3}</span>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
        ) : (
          <div></div>
        )}
      </ol>
    </div>
  )
}

const RenderMCIRiderBenefitsHeadTitle = (props) => {
  const { headTitle } = props
  return <h3>{headTitle}</h3>
}

const BenefitTableHeader = (props) => {
  const { maxBenefitPerAnnualPolicy, maxBenefitPerPolicy, numberDiseaseCoverage, planCode } = props
  return (
    <thead>
      <tr>
        <td colSpan={3} style={{ width: '54.89%' }}>
          <CenterStyled>{numberDiseaseCoverage.title}</CenterStyled>
        </td>
        <td style={{ width: '45.12%' }}>
          <CenterStyled>{findDataOnListByRiderCode(numberDiseaseCoverage.benefit, planCode)}</CenterStyled>
        </td>
      </tr>
      <tr>
        <td style={{ width: '40.75%' }}>{MESSAGES.BENEFIT_TITLE}</td>
        <td style={{ width: '14.14%' }}>{MESSAGES.BENEFIT_BAHT}</td>
        <td style={{ width: '17.87%' }}>{MESSAGES.RIDER_BENEFIT_DAY_OR_TIME}</td>
        <td style={{ width: '27.25%' }}>{MESSAGES.RIDER_TOTAL_BENEFIT_BAHT_HAVE_STAR}</td>
      </tr>
    </thead>
  )
}

const RenderMCIRiderBenefitsTable = (props) => {
  const { maxBenefitPerAnnualPolicy, maxBenefitPerPolicy, numberDiseaseCoverage, benefits, planCode } = props
  const { title, titlePlan, contents } = benefits
  return (
    <div className="mex-details-table">
      <h3>
        {title} {findDataOnListByRiderCode(titlePlan, planCode)}
      </h3>
      <table id="mex-benefit-table">
        <BenefitTableHeader
          maxBenefitPerAnnualPolicy={maxBenefitPerAnnualPolicy}
          maxBenefitPerPolicy={maxBenefitPerPolicy}
          numberDiseaseCoverage={numberDiseaseCoverage}
          planCode={planCode}
        />
        <tbody>
          <tr>
            <td colSpan={4}>
              <BoldStyled>{contents.subject_1}</BoldStyled>
            </td>
          </tr>
          <tr>
            <td>
              <BoldStyled>{contents.group_1.title_group}</BoldStyled>
              <WordWraps>{contents.group_1.title[0]}</WordWraps>
              <br />
              &emsp;<WordWraps>{contents.group_1.title[1]}</WordWraps>
            </td>
            <td>
              <CenterStyled>{findDataOnListByRiderCode(contents.group_1.benefit, planCode)}</CenterStyled>
            </td>
            <td>
              <CenterStyled>{contents.group_1.totalTimes}</CenterStyled>
            </td>
            <td rowSpan={25} className="align-top">
              <CenterStyled>
                {' '}
                {findDataOnListByRiderCode(maxBenefitPerAnnualPolicy.benefit, planCode)}
                <WordWraps>{' ต่อรอบปีกรมธรรม์ประกันภัย'}</WordWraps>
                <br />
                {findDataOnListByRiderCode(maxBenefitPerPolicy.benefit, planCode)}
                <WordWraps>{' ตลอดอายุของผู้เอาประกันภัยที่มีการรับประกันภัยนี้'}</WordWraps>
              </CenterStyled>
            </td>
          </tr>
          <tr>
            <td colSpan={3}>
              <BoldStyled>{contents.group_2.title_group}</BoldStyled>
              <WordWraps>{contents.group_2.title}</WordWraps>
            </td>
          </tr>
          <tr>
            <td>
              <WordWraps>{contents.group_2_1.title}</WordWraps>
            </td>
            <td>
              <CenterStyled>{contents.group_2_1.benefit}</CenterStyled>
            </td>
            <td>
              <CenterStyled>{contents.group_2_1.totalTimes}</CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <WordWraps>{contents.group_2_2.title}</WordWraps>
            </td>
            <td>
              <CenterStyled>{contents.group_2_2.benefit}</CenterStyled>
            </td>
            <td>
              <CenterStyled>{contents.group_2_2.totalTimes}</CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <WordWraps>{contents.group_2_3.title}</WordWraps>
            </td>
            <td>
              <CenterStyled>{contents.group_2_3.benefit}</CenterStyled>
            </td>
            <td>
              <CenterStyled>{contents.group_2_3.totalTimes}</CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <WordWraps>{contents.group_2_4.title}</WordWraps>
            </td>
            <td>
              <CenterStyled>{contents.group_2_4.benefit}</CenterStyled>
            </td>
            <td>
              <CenterStyled>
                <WordWraps>{contents.group_2_4.totalTimes.replace(/\n/g, '')}</WordWraps>
              </CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <BoldStyled>{contents.group_3.title_group}</BoldStyled>
              <WordWraps>{contents.group_3.title}</WordWraps>
            </td>
            <td>
              <CenterStyled>{contents.group_3.benefit}</CenterStyled>
            </td>
            <td>
              <CenterStyled>{contents.group_3.totalTimes}</CenterStyled>
            </td>
          </tr>
          <tr>
            <td colSpan={3}>
              <BoldStyled>{contents.group_4.title_group}</BoldStyled>
              <WordWraps>{contents.group_4.title}</WordWraps>
            </td>
          </tr>
          <tr>
            <td>
              <WordWraps>{contents.group_4_1.title}</WordWraps>
            </td>
            <td>
              <CenterStyled>{contents.group_4_1.benefit}</CenterStyled>
            </td>
            <td>
              <CenterStyled>{contents.group_4_1.totalTimes}</CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <WordWraps>{contents.group_4_2.title}</WordWraps>
            </td>
            <td>
              <CenterStyled>{contents.group_4_2.benefit}</CenterStyled>
            </td>
            <td>
              <CenterStyled>{contents.group_4_2.totalTimes}</CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <WordWraps>{contents.group_4_3.title.replace(/\n/g, '')}</WordWraps>
            </td>
            <td>
              <CenterStyled>{contents.group_4_3.benefit}</CenterStyled>
            </td>
            <td>
              <CenterStyled>{contents.group_4_3.totalTimes}</CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <WordWraps>{contents.group_4_4.title}</WordWraps>
            </td>
            <td>
              <CenterStyled>{contents.group_4_4.benefit}</CenterStyled>
            </td>
            <td>
              <CenterStyled>{contents.group_4_4.totalTimes}</CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <WordWraps>{contents.group_4_5.title}</WordWraps>
            </td>
            <td>
              <CenterStyled>{contents.group_4_5.benefit}</CenterStyled>
            </td>
            <td>
              <CenterStyled>{contents.group_4_5.totalTimes}</CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <BoldStyled>{contents.group_5.title_group}</BoldStyled>
              <WordWraps>{contents.group_5.title}</WordWraps>
            </td>
            <td>
              <CenterStyled>{contents.group_5.benefit}</CenterStyled>
            </td>
            <td>
              <CenterStyled>{contents.group_5.totalTimes}</CenterStyled>
            </td>
          </tr>
          <tr>
            <td colSpan={3}>
              <BoldStyled>{contents.subject_2}</BoldStyled>
            </td>
          </tr>
          <tr>
            <td colSpan={3}>
              <BoldStyled>{contents.group_6.title_group}</BoldStyled>
              <WordWraps>{contents.group_6.title}</WordWraps>
            </td>
          </tr>
          <tr>
            <td>
              <WordWraps>{contents.group_6_1.title.replace(/\n/g, '')}</WordWraps>
            </td>
            <td>
              <CenterStyled>{contents.group_6_1.benefit}</CenterStyled>
            </td>
            <td>
              <CenterStyled>{contents.group_6_1.totalTimes}</CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <WordWraps>{contents.group_6_2.title.replace(/\n/g, '')}</WordWraps>
            </td>
            <td>
              <CenterStyled>{contents.group_6_2.benefit}</CenterStyled>
            </td>
            <td>
              <CenterStyled>
                <WordWraps>{contents.group_6_2.totalTimes.replace(/\n/g, '')}</WordWraps>
              </CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <BoldStyled>{contents.group_7.title_group}</BoldStyled>
              <WordWraps>{contents.group_7.title}</WordWraps>
            </td>
            <td>
              <CenterStyled>{contents.group_7.benefit}</CenterStyled>
            </td>
            <td>
              <CenterStyled>{contents.group_7.totalTimes}</CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <BoldStyled>{contents.group_8.title_group}</BoldStyled>
              <WordWraps>{contents.group_8.title.replace(/\n/g, '')}</WordWraps>
            </td>
            <td>
              <CenterStyled>
                <WordWraps>{findDataOnListByRiderCode(contents.group_8.benefit, planCode)}</WordWraps>
              </CenterStyled>
            </td>
            <td>
              <CenterStyled>
                <WordWraps>{findDataOnListByRiderCode(contents.group_8.totalTimes, planCode)}</WordWraps>
              </CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <BoldStyled>{contents.group_9.title_group}</BoldStyled>
              <WordWraps>{contents.group_9.title}</WordWraps>
            </td>
            <td>
              <CenterStyled>{contents.group_9.benefit}</CenterStyled>
            </td>
            <td>
              <CenterStyled>{contents.group_9.totalTimes}</CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <BoldStyled>{contents.group_10.title_group}</BoldStyled>
              <WordWraps>{contents.group_10.title}</WordWraps>
            </td>
            <td>
              <CenterStyled>{contents.group_10.benefit}</CenterStyled>
            </td>
            <td>
              <CenterStyled>{contents.group_10.totalTimes}</CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <BoldStyled>{contents.group_11.title_group}</BoldStyled>
              <WordWraps>{contents.group_11.title}</WordWraps>
            </td>
            <td>
              <CenterStyled>{contents.group_11.benefit}</CenterStyled>
            </td>
            <td>
              <CenterStyled>{contents.group_11.totalTimes}</CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <BoldStyled>{contents.group_12.title_group}</BoldStyled>
              <WordWraps>{contents.group_12.title}</WordWraps>
            </td>
            <td>
              <CenterStyled>{contents.group_12.benefit}</CenterStyled>
            </td>
            <td>
              <CenterStyled>{contents.group_12.totalTimes}</CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <BoldStyled>{contents.group_13.title_group}</BoldStyled>
              <WordWraps>{contents.group_13.title}</WordWraps>
            </td>
            <td>
              <CenterStyled>{contents.group_13.benefit}</CenterStyled>
            </td>
            <td>
              <CenterStyled>{contents.group_13.totalTimes}</CenterStyled>
            </td>
          </tr>
          <tr>
            <td colSpan={4}>
              <UnderlineStyled>
                <BoldStyled>{'การมีส่วนร่วมจ่าย'}</BoldStyled>
              </UnderlineStyled>
            </td>
          </tr>
          <tr>
            <td>
              <WordWraps>{contents.deduct_copay.deduct.title}</WordWraps>
            </td>
            <td colSpan={3}>
              <CenterStyled>
                <WordWraps>{contents.deduct_copay.deduct.benefit}</WordWraps>
              </CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <WordWraps>{contents.deduct_copay.copay.title}</WordWraps>
            </td>
            <td colSpan={3}>
              <CenterStyled>
                <WordWraps>{contents.deduct_copay.copay.benefit}</WordWraps>
              </CenterStyled>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

const RenderMCIRiderBenefitsDisclaimer = (props) => {
  const { benefits, insureAge } = props
  return (
    <div>
      <div>
        <WordWraps>{benefits.remark.remark_1}</WordWraps>
      </div>
      {insureAge.value < 11 ? (
        <div>
          <WordWraps>{benefits.remark.remark_2}</WordWraps>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  )
}

const EndorseTableHeader = () => {
  return (
    <thead>
      <tr>
        <td style={{ width: '40.75%' }}>{MESSAGES.BENEFIT_TITLE}</td>
        <td style={{ width: '14.14%' }}>{MESSAGES.BENEFIT_BAHT}</td>
        <td style={{ width: '17.87%' }}>{MESSAGES.RIDER_BENEFIT_DAY_OR_TIME}</td>
        <td style={{ width: '27.25%' }}>{MESSAGES.RIDER_TOTAL_BENEFIT_BAHT_HAVE_STAR}</td>
      </tr>
    </thead>
  )
}

const RenderMCIRiderEndorseTable = (props) => {
  const { maxBenefitPerAnnualPolicy, maxBenefitPerPolicy, endorse, planCode } = props
  const { title, titlePlan, contents } = endorse
  return (
    <div className="mex-details-table">
      <h3>
        {title} {findDataOnListByRiderCode(titlePlan, planCode)}
      </h3>
      <table id="mci-endorse-table">
        <EndorseTableHeader />
        <tbody>
          <tr>
            <td>
              <BoldStyled>{contents.group_14.title_group}</BoldStyled>
              <WordWraps>{contents.group_14.title.replace(/\n/g, '')}</WordWraps>
            </td>
            <td>
              <CenterStyled>
                <WordWraps>{findDataOnListByRiderCode(contents.group_14.benefit, planCode)}</WordWraps>
              </CenterStyled>
            </td>
            <td>
              <CenterStyled>
                <WordWraps>{findDataOnListByRiderCode(contents.group_14.totalTimes, planCode)}</WordWraps>
              </CenterStyled>
            </td>
            <td rowSpan={3} className="align-top">
              {['MCI1J', 'MCI1S'].includes(planCode) ? (
                <CenterStyled>{'-'}</CenterStyled>
              ) : (
                <CenterStyled>
                  {' '}
                  {findDataOnListByRiderCode(maxBenefitPerAnnualPolicy.benefit, planCode)}
                  <WordWraps>{' ต่อรอบปีกรมธรรม์ประกันภัย'}</WordWraps>
                  <br />
                  {findDataOnListByRiderCode(maxBenefitPerPolicy.benefit, planCode)}
                  <WordWraps>{' ตลอดอายุของผู้เอาประกันภัยที่มีการรับประกันภัยนี้'}</WordWraps>
                </CenterStyled>
              )}
            </td>
          </tr>
          <tr>
            <td>
              <BoldStyled>{contents.group_15.title_group}</BoldStyled>
              <WordWraps>{contents.group_15.title.replace(/\n/g, '')}</WordWraps>
            </td>
            <td>
              <CenterStyled>{findDataOnListByRiderCode(contents.group_15.benefit, planCode)}</CenterStyled>
            </td>
            <td>
              <CenterStyled>
                <WordWraps>{contents.group_15.totalTimes}</WordWraps>
              </CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <BoldStyled>{contents.group_16.title_group}</BoldStyled>
              <WordWraps>{contents.group_16.title.replace(/\n/g, '')}</WordWraps>
            </td>
            <td>
              <CenterStyled>{findDataOnListByRiderCode(contents.group_16.benefit, planCode)}</CenterStyled>
            </td>
            <td>
              <CenterStyled>
                <WordWraps>{contents.group_16.totalTimes}</WordWraps>
              </CenterStyled>
            </td>
          </tr>
          <tr>
            <td colSpan={4}>
              <UnderlineStyled>
                <BoldStyled>{'การมีส่วนร่วมจ่าย'}</BoldStyled>
              </UnderlineStyled>
            </td>
          </tr>
          <tr>
            <td>
              <WordWraps>{contents.deduct_copay.deduct.title}</WordWraps>
            </td>
            <td colSpan={3}>
              <CenterStyled>
                <WordWraps>{contents.deduct_copay.deduct.benefit}</WordWraps>
              </CenterStyled>
            </td>
          </tr>
          <tr>
            <td>
              <WordWraps>{contents.deduct_copay.copay.title}</WordWraps>
            </td>
            <td colSpan={3}>
              <CenterStyled>
                <WordWraps>{contents.deduct_copay.copay.benefit}</WordWraps>
              </CenterStyled>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

const RenderMCIRiderEndorseDisclaimer = (props) => {
  const { endorse, planCode } = props
  return (
    <div>
      <div>
        <WordWraps>{endorse.remark.remark_1}</WordWraps>
      </div>
      {!['MCI1J', 'MCI1S'].includes(planCode) ? (
        <div>
          <WordWraps>{endorse.remark.remark_2}</WordWraps>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  )
}

const MCIRiderBenefit = (props) => {
  const { rider, riderBenefitData, insureAge } = props
  const title = `${rider.description} (${rider.code})`
  const planCode = getMCIRiderPlanCode(rider, insureAge)
  const {
    headTitle,
    headSubTitle,
    maxBenefitPerAnnualPolicy,
    maxBenefitPerPolicy,
    numberDiseaseCoverage,
    benefits,
    endorse,
  } = riderBenefitData

  const benefitInfo = (
    <div>
      <RenderMCIRiderBenefitsHeadTitle headTitle={headTitle} />
      <RenderMCIRiderBenefitsHeadTitle headTitle={headSubTitle} />

      <RenderMCIRiderBenefitsTable
        maxBenefitPerAnnualPolicy={maxBenefitPerAnnualPolicy}
        maxBenefitPerPolicy={maxBenefitPerPolicy}
        numberDiseaseCoverage={numberDiseaseCoverage}
        benefits={benefits}
        planCode={planCode}
      />
      <RenderMCIRiderBenefitsDisclaimer benefits={benefits} insureAge={insureAge} />
      <br />
      <RenderMCIRiderEndorseTable
        maxBenefitPerAnnualPolicy={maxBenefitPerAnnualPolicy}
        maxBenefitPerPolicy={maxBenefitPerPolicy}
        endorse={endorse}
        planCode={planCode}
      />
      <RenderMCIRiderEndorseDisclaimer endorse={endorse} planCode={planCode} />
      <br />
    </div>
  )

  return (
    <RiderWithBenefitModal
      id="mci-rider-benefit"
      className="rider mexmea-plus-rider-rider"
      title={title}
      modalChildren={benefitInfo}
    >
      <RiderBenefitSummary rider={rider} title={title} />
      {benefitInfo}
      {renderExceptionNotes(rider)}
      <AdditionalDisclaimer
        rider={rider}
        overrideTitle={`${MESSAGES.MEDICAL_FEE} ${rider.description} (${rider.code})`}
      />
      {renderExplanationNotes(insureAge)}
    </RiderWithBenefitModal>
  )
}

export default MCIRiderBenefit
